import { handleActions } from 'redux-actions';

import types from '@/actions/commonTypes';

const initialState = {
  loading: false,
  title: '',
  message: '',
  close: undefined,
  isErrorOpen: false,
};

/* Reducer */
export default handleActions({
  [types.LOADING]: (state, action) => {
    return { ...state,
      loading: true
    }
  },
  [types.LOADED]: (state, action) => {
    return { ...state,
      loading: false
    }
  },
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js